export default __webpack_public_path__ + "static/media/trial_expired.5a3ad4ab.png";